import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import "./../custom.css";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import { autoResizeTextarea } from "../../../core/common/autoResizeTextarea";
import { employee_id } from "../../../environment";
import { getFinancialYearListNew } from "../../../core/common/financialYear";

const EmployeePMS = () => {
  const [finance_year, setFinance_year] = useState("");

  const {
    data: finYearData,
    loading: finYearLoading,
    error: finYearError,
  } = useApi("/api/get-apprisal-fin-year", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (finYearData?.data?.fin_year) {
      setFinance_year(finYearData.data.fin_year);
    }
  }, [finYearData]);

  const [countKra, setCountKra] = useState(1);
  const [countBeha, setCountBeha] = useState(1);
  const [countPotensial, setCountPotensial] = useState(1);
  const [countOverAll, setCountOverAll] = useState(1);
  const [countApproved, setCountApproved] = useState(1);
  const [activetab, setActivetab] = useState<any>("kra");
  const [kraDetailsData, setKraDetailsData] = useState<any>([]);
  const [behaDetailsData, setBehaDetailsData] = useState<any>([]);
  const [potentialData, setPotentialData] = useState<any>([]);
  const [ratingData, setRatingData] = useState<any>([]);
  const [comaspiDetailsData, setComaspiDetailsData] = useState<any>({
    comments: "",
  });
  const routes = all_routes;

  const ratingOptions = [
    { value: "OS", label: "Outstanding (OS)" },
    { value: "VG", label: "Very Good (VG)" },
    { value: "G", label: "Good (G)" },
    { value: "AVG", label: "Average (Avg)" },
    { value: "P", label: "Poor (P)" },
  ];
  const ratingBehaiviroul = [
    { value: "P", label: "L1" },
    { value: "AVG", label: "L2" },
    { value: "G", label: "L3" },
    { value: "VG", label: "L4" },
    // { value: "OS", label: "L5" },
  ];
  const tabs = [
    { value: "kra", label: "KRA 80%" },
    { value: "Potential", label: "Potential 20%" },
    { value: "Behavioural Competence", label: "Behavioural Competence" },
    { value: "Overall Comments", label: "Overall Comments" },
  ];

  const {
    data: getGoalProfileStatus,
    loading: GoalProfileStatusLoading,
    error: GoalProfileStatusError,
  } = useApi("/api/get-goal-profile-status", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year],
  });

  const {
    data: getappraisalTiming,
    loading: appraisalTimingLoading,
    error: appraisalTimingError,
  } = useApi("/api/get-apparisal-timing", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year],
  });

  console.log(getappraisalTiming, "getappraisalTiming");

  const {
    data: getkradetails,
    loading: kradetailsLoading,
    error: kradetailsError,
  } = useApi("/api/get-kra-appraisal", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year, countKra],
  });

  const {
    data: getbehaiviourdetails,
    loading: behaiviourdetailsLoading,
    error: behaiviourdetailsError,
  } = useApi("/api/get-behaiviroual-appraisal", {
    method: "POST",
    payload: {
      financial_year: finance_year,
      role: "SELF",
    },
    autoCall: !!finance_year,
    dependencies: [finance_year, countBeha],
  });

  const {
    data: getPotentialdetails,
    loading: PotentialdetailsLoading,
    error: PotentialdetailsError,
  } = useApi("/api/get-potensial-appraisal", {
    method: "POST",
    payload: {
      financial_year: finance_year,
      role: "SELF",
    },
    autoCall: !!finance_year,
    dependencies: [finance_year, countPotensial],
  });
  const {
    data: getRatingdetails,
    loading: RatingdetailsLoading,
    error: RatingdetailsError,
  } = useApi("/api/get-rating", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: getcomaspidetails,
    loading: comaspidetailsLoading,
    error: comaspidetailsError,
  } = useApi("/api/get-overall-comments", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year, countOverAll],
  });

  const {
    data: getPMSStatus,
    loading: PMSStatusLoading,
    error: PMSStatusError,
  } = useApi("/api/get-employee-pms-status", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year, countOverAll],
  });

  const {
    data: getPMSStatusManager,
    loading: PMSStatusManagerLoading,
    error: PMSStatusManagerError,
  } = useApi("/api/get-employee-response", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year, countApproved],
  });

  const {
    data: getPMStotalRating,
    loading: PMStotalRatingLoading,
    error: PMStotalRatingError,
  } = useApi("/api/get-employee-pms-rating", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    dependencies: [finance_year, countKra, countPotensial],
    autoCall: !!finance_year,
  });

  const {
    data: getstatus,
    loading: statusLoading,
    error: statusError,
  } = useApi("/api/get-pms-status", {
    method: "POST",
    payload: {
      employee_id: employee_id,
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year, countKra, countOverAll, countApproved],
  });

  useEffect(() => {
    if (getkradetails?.success) {
      const data = getkradetails?.data;
      setKraDetailsData(data);
    }
  }, [getkradetails]);

  useEffect(() => {
    if (getbehaiviourdetails?.success) {
      setBehaDetailsData(getbehaiviourdetails?.data);
    }
  }, [getbehaiviourdetails]);

  // useEffect(() => {
  //   if (getbehaiviourdetails?.success && getbehaiviourdetails?.data) {
  //     const formatted = getbehaiviourdetails.data.map((item: any) => {
  //       // Find the description that already contains rating or achievement
  //       const selected = item.description.find((d: any) => d.rating !== null || d.achievement !== null);

  //       return {
  //         ...item,
  //         selected_description_id: selected?.description_id || null,
  //         rating: selected?.rating || "",
  //         achievement: selected?.achievement || ""
  //       };
  //     });

  //     setBehaDetailsData(formatted);
  //   }
  // }, [getbehaiviourdetails]);

  useEffect(() => {
    if (getPotentialdetails?.success) {
      setPotentialData(getPotentialdetails?.data);
    }
  }, [getPotentialdetails]);

  useEffect(() => {
    if (getRatingdetails?.success) {
      setRatingData(getRatingdetails?.data);
    }
  }, [getRatingdetails]);

  useEffect(() => {
    if (getcomaspidetails?.success) {
      setComaspiDetailsData(getcomaspidetails?.data);
    }
  }, [getcomaspidetails]);

  const handleKraChange = (index: number, field: string, value: any) => {
    console.log(index, field, value);
    const updatedData = [...kraDetailsData];
    updatedData[index][field] = value;
    setKraDetailsData(updatedData);
  };

  const handlePotensialChange = (
    categoryIndex: number,
    subcategoryIndex: number,
    field: string,
    value: any,
  ) => {
    const updated = [...potentialData];

    updated[categoryIndex].subcategories[subcategoryIndex][field] = value;

    setPotentialData(updated);
  };

  const handleBrhaChange = (index: number, field: string, value: any) => {
    const updatedData = [...behaDetailsData];
    updatedData[index][field] = value;
    setBehaDetailsData(updatedData);
  };

  const getInputdata = (e: any) => {
    const { name, value } = e.target;
    setComaspiDetailsData({ ...comaspiDetailsData, [name]: value });
  };

  const {
    data: addkraRatingdetails,
    loading: addkraRatingdetailsLoading,
    error: addkraRatingdetailsError,
    callApi: AddRaitingKra,
  } = useApi("/api/add-kra-appraisal", {
    method: "POST",
    autoCall: false,
  });

  const handleSaveOrSubmit = async (e: any) => {
    e.preventDefault();

    if (kraDetailsData.length === 0) return;

    const filteredData = kraDetailsData.filter(
      (item: any) => item.rating && item.achievement !== null,
    );

    const payload = {
      financial_year: finance_year,
      role: "SELF",
      appraisal_data: filteredData.map((item: any) => ({
        kra_id: item.kra_id.toString(),
        rating: item.rating,
        achievement: item.achievement,
      })),
    };
    try {
      const response = await AddRaitingKra(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setActivetab("Potential");
        });
      }
      setCountKra(countKra + 1);
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: addBehaRatingdetails,
    loading: addBehaRatingdetailsLoading,
    error: addBehaRatingdetailsError,
    callApi: AddRaitingBeha,
  } = useApi("/api/add-behaiviroual-appraisal", {
    method: "POST",
    autoCall: false,
  });

  const handleSaveOrSubmitBeha = async (e: any) => {
    e.preventDefault();

    if (!behaDetailsData || behaDetailsData.length === 0) return;
    const filteredData = behaDetailsData.filter(
      (item: any) => item.rating && item.achievement !== null,
    );
    const apprisalData = filteredData.map((item: any) => ({
      competency_id: item.ID,
      rating: item.rating || null,
      achievement: item.achievement || "",
    }));

    if (filteredData.length === 0) {
      Swal.fire({
        title: "Warning",
        text: "Please select at least one description and fill rating/achievement.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const payload = {
      financial_year: finance_year,
      role: "SELF",
      apprisal_data: apprisalData,
    };

    try {
      const response = await AddRaitingBeha(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setActivetab("Overall Comments");
        });
      }
      setCountBeha(countBeha + 1);
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message || "Something went wrong",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: addPotensialRatingdetails,
    loading: addPotensialRatingdetailsLoading,
    error: addPotensialRatingdetailsError,
    callApi: AddRaitingPotensial,
  } = useApi("/api/add-potensial-appraisal", {
    method: "POST",
    autoCall: false,
  });

  const handleSaveOrSubmitPotensial = async (e: any) => {
    e.preventDefault();

    if (potentialData.length === 0) return;
    const apprisal_data: any[] = [];

    potentialData.forEach((category: any) => {
      category.subcategories.forEach((sub: any) => {
        if (sub.rating && sub.achievement) {
          apprisal_data.push({
            subcategory_id: sub.id,
            rating: sub.rating,
            achievement: sub.achievement,
          });
        }
      });
    });

    const payload = {
      financial_year: finance_year,
      role: "SELF",
      apprisal_data: apprisal_data,
    };

    try {
      const response = await AddRaitingPotensial(payload);

      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          setActivetab("Behavioural Competence");
        });
      }
      setCountPotensial(countPotensial + 1);
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: addComAspiRatingdetails,
    loading: addComAspiRatingdetailsLoading,
    error: addComAspiRatingdetailsError,
    callApi: AddRaitingComAspi,
  } = useApi("/api/add-overall-comments", {
    method: "POST",
    autoCall: false,
  });

  const handleSaveOrSubmitComAspi = async (e: any) => {
    e.preventDefault();
    const payload = {
      financial_year: finance_year,
      role: "SELF",
      carrier_aspiration: comaspiDetailsData.ID,
      comments: comaspiDetailsData.comments,
    };
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once you submit the performance review, you won't be able to make any changes.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      return;
    }
    try {
      const response = await AddRaitingComAspi(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      }
      setCountOverAll(countOverAll + 1);
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: addApprisalAsEmployee,
    loading: addApprisalAsEmployeeLoading,
    error: addApprisalAsEmployeeError,
    callApi: AddApprisalAsEmployee,
  } = useApi("/api/add-employee-response", {
    method: "POST",
    autoCall: false,
  });

  const ApprovedApprisalAsEmployee = async (e: any, status: any) => {
    e.preventDefault();

    let reject_reason = "";

    if (status === "Reject") {
      const { value: reason } = await Swal.fire({
        title: "Revert Appraisal",
        input: "textarea",
        inputLabel: "Please provide revert reason",
        inputPlaceholder: "Enter reason here...",
        inputAttributes: {
          "aria-label": "Reject reason",
        },
        showCancelButton: true,
        confirmButtonText: "Yes Revert",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value) {
            return "Revert reason is required!";
          }
        },
      });

      if (!reason) return; // user cancelled

      reject_reason = reason;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text:
        status === "Reject"
          ? "Are you sure you want to revert the appraisal?"
          : "Are you sure you want to approve the appraisal?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: status === "Reject" ? "Yes, Revert" : "Yes, Approve",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    const payload = {
      financial_year: finance_year,
      status: status,
      rejected_reason: reject_reason,
    };

    try {
      const response = await AddApprisalAsEmployee(payload);

      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      }

      setCountApproved(countApproved + 1);
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const parseTarget = (target: any) => {
    try {
      if (!target) return [];
      return JSON.parse(target);
    } catch (e) {
      console.error("Error parsing target:", target);
      return [target]; // fallback
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Performance Review</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">PMS</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Performance Review
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="me-2 mb-2"></div>
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>

                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearListNew(finance_year).map((fy: any) => (
                    <option key={fy} value={fy}>
                      {fy}
                    </option>
                  ))}
                </select>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {getappraisalTiming?.data?.status === "excluded" ||
          !getappraisalTiming?.data ? (
            <section className="container mt-5">
              <div className="card shadow-sm border-danger text-center">
                <div className="card-body">
                  <div className="mb-3">
                    <i className="bi bi-exclamation-triangle-fill text-danger fs-1"></i>
                  </div>
                  <h4 className="card-title text-danger mb-3">
                    Appraisal Update
                  </h4>
                  <p className="card-text">
                    You have been excluded from the appraisal process for the
                    current financial year.
                  </p>
                  <p className="text-muted">
                    Please contact the HR department for further clarification.
                  </p>
                </div>
              </div>
            </section>
          ) : (
            <section className="custom-card">
              <div className="custom-card-header d-flex justify-content-between align-items-center">
                <div className="d-flex gap-2">
                  {tabs.map((item, index) => (
                    <button
                      className={`${
                        activetab === item.value
                          ? "btn btn-primary custom_button"
                          : "btn btn-primary tab-button"
                      }`}
                      onClick={() => {
                        setActivetab(item.value);
                      }}
                      // style={{ border: "2px solid red" }}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
                <div className="d-flex gap-3">
                  <div>
                    <span
                      className={`badge `}
                      style={{ backgroundColor: "#2e3294" }}
                    >
                      Status : {getstatus?.status}
                    </span>
                  </div>

                  <button
                    className="btn btn-outline-secondary"
                    data-bs-toggle="modal"
                    data-bs-target={
                      activetab === "Behavioural Competence"
                        ? "#behaviouralinfo"
                        : "#ratinginfo"
                    }
                  >
                    <i className="fa fa-users"></i>
                  </button>
                </div>
              </div>

              {activetab === "kra" ? (
                <>
                  {getGoalProfileStatus?.data?.status === "M Approved" ? (
                    <>
                      {kraDetailsData && kraDetailsData.length > 0 ? (
                        <div className="custom-table-wrapper">
                          <div className="custom-table-responsive">
                            <table className="custom-table">
                              <thead>
                                <tr>
                                  <th>SNo</th>
                                  {/* <th>Category</th> */}
                                  <th>Smart Goal</th>
                                  <th>Target</th>
                                  <th>Date</th>
                                  <th>File</th>
                                  <th>Wt(%)</th>
                                  <th>Unit</th>
                                  <th>Rating</th>
                                  <th>Achievement</th>
                                </tr>
                              </thead>
                              <tbody>
                                {kraDetailsData.map((item: any, idx: any) => {
                                  return (
                                    <tr key={item.id}>
                                      <td className="allcolor">{idx + 1}</td>

                                      <td className="allcolor">
                                        <p>
                                          <strong>{item.smart_goals}</strong>
                                        </p>
                                        <p>{item.kra_category_name}</p>
                                      </td>
                                      <td className="allcolor">
                                        <ul className="mb-0">
                                          {parseTarget(item.target).map(
                                            (t: any, idx: any) => (
                                              <li key={idx}>
                                                {/* {idx + 1}.  */}
                                                {t}
                                              </li>
                                            ),
                                          )}
                                        </ul>
                                      </td>
                                      <td className="allcolor">
                                        {item.target_achievement_date}
                                      </td>
                                      <td className="allcolor">
                                        {!item.attachment_url ||
                                        item.attachment_url.endsWith(
                                          "/null",
                                        ) ? (
                                          "N/A"
                                        ) : (
                                          <a
                                            href={item.attachment_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                              color: "blue",
                                              textDecoration: "underline",
                                            }}
                                          >
                                            View
                                          </a>
                                        )}
                                      </td>
                                      <td className="allcolor">
                                        {item.weightage}
                                      </td>
                                      <td className="allcolor">
                                        <p>{item.unit}</p>
                                      </td>
                                      <td>
                                        <select
                                          className="form-select"
                                          value={item.rating || ""}
                                          onChange={(e) =>
                                            handleKraChange(
                                              idx,
                                              "rating",
                                              e.target.value,
                                            )
                                          }
                                          disabled={
                                            getPMSStatus?.data?.status ===
                                            "Submit"
                                          }
                                        >
                                          <option value="">
                                            Select Rating
                                          </option>
                                          {ratingOptions.map(
                                            (option: any, index: any) => (
                                              <option
                                                key={index}
                                                value={option.value}
                                              >
                                                {option.label}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      </td>
                                      <td>
                                        <textarea
                                          className="custom-textarea"
                                          name="achievement"
                                          value={item.achievement || ""}
                                          readOnly={
                                            item.status === "E_SUBMIT" ||
                                            item.status === "M_APPROVED"
                                          }
                                          onChange={(e) => {
                                            handleKraChange(
                                              idx,
                                              "achievement",
                                              e.target.value,
                                            );
                                            autoResizeTextarea(e.target);
                                          }}
                                          onInput={(e) =>
                                            autoResizeTextarea(e.currentTarget)
                                          }
                                          style={{ overflow: "hidden" }}
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                          <div className="p-2 d-flex justify-content-end gap-2">
                            {(() => {
                              const endDate =
                                getappraisalTiming?.data?.employee_end_date;
                              const today = new Date();
                              const isExpired =
                                endDate &&
                                new Date(endDate) <
                                  new Date(today.toISOString().split("T")[0]);

                              if (
                                isExpired ||
                                getappraisalTiming?.data
                                  ?.apprisal_cycle_status === "closed" ||
                                getappraisalTiming?.data
                                  ?.apprisal_cycle_status === "suspended"
                              ) {
                                return (
                                  <div className="alert alert-danger mb-0 text-center w-100">
                                    Your appraisal submission date is over.
                                    Please contact the HR team.
                                  </div>
                                );
                              }

                              if (getPMSStatus?.data?.status === "Submit") {
                                return null;
                              }

                              return (
                                <button
                                  className="btn btn-primary tab-button"
                                  onClick={(e: any) => handleSaveOrSubmit(e)}
                                >
                                  Save & Next
                                </button>
                              );
                            })()}
                          </div>
                        </div>
                      ) : (
                        <div className="p-2 d-flex justify-content-center">
                          <p
                            className="text-danger fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            No KRA records found.
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="p-3 text-center">
                      <p
                        className="fw-bold text-primary"
                        style={{ fontSize: "15px" }}
                      >
                        KRA details will be available once the Goal Profile is
                        approved by your Manager.
                      </p>
                      <p className="text-muted">
                        Current Status:{" "}
                        <strong>
                          {getGoalProfileStatus?.data?.status === "E Submit"
                            ? "Employee Submit"
                            : getGoalProfileStatus?.data?.status ===
                                "M Approved"
                              ? "Manager Approved"
                              : "Rejected"}
                        </strong>
                      </p>
                    </div>
                  )}
                </>
              ) : activetab === "Behavioural Competence" ? (
                <>
                  {getGoalProfileStatus?.data?.status === "M Approved" ? (
                    <>
                      {behaDetailsData && behaDetailsData?.length > 0 ? (
                        <div className="custom-table-wrapper">
                          <div className="custom-table-responsive">
                            <table className="custom-table">
                              <thead>
                                <tr>
                                  <th>SNo</th>
                                  <th>Behavioural Competency</th>
                                  <th>Description</th>
                                  {/* <th>Weightage(%)</th> */}
                                  <th>Self Rating</th>
                                  <th>Self Achievement</th>
                                </tr>
                              </thead>
                              <tbody>
                                {behaDetailsData?.map(
                                  (item: any, compIdx: any) => {
                                    return (
                                      <tr key={item.id}>
                                        <td className="allcolor">
                                          {compIdx + 1}
                                        </td>
                                        <td className="allcolor">
                                          <p>{item?.competency}</p>
                                        </td>
                                        <td className="allcolor">
                                          <ul className="radio-list">
                                            {item?.descriptions?.map(
                                              (desc: any, index: any) => (
                                                <li key={desc.description_id}>
                                                  <label
                                                    htmlFor={`competency-${compIdx}-${desc.description_id}`}
                                                  >
                                                    {"L" + (index + 1)}-&nbsp;
                                                    {desc?.description}
                                                  </label>
                                                </li>
                                              ),
                                            )}
                                          </ul>
                                        </td>
                                        <td>
                                          <select
                                            name=""
                                            value={item?.rating}
                                            className="form-select"
                                            disabled={
                                              getPMSStatus?.data?.status ===
                                              "Submit"
                                            }
                                            onChange={(e) =>
                                              handleBrhaChange(
                                                compIdx,
                                                "rating",
                                                e.target.value,
                                              )
                                            }
                                          >
                                            <option value="">
                                              Select Rating
                                            </option>
                                            {ratingBehaiviroul?.map(
                                              (item: any, index: any) => (
                                                <option value={item.value}>
                                                  {item?.label}
                                                </option>
                                              ),
                                            )}
                                          </select>
                                        </td>
                                        <td>
                                          <textarea
                                            className="custom-textarea"
                                            name="achievement"
                                            value={item?.achievement || ""}
                                            readOnly={
                                              getPMSStatus?.data?.status ===
                                              "Submit"
                                            }
                                            onChange={(e) => {
                                              handleBrhaChange(
                                                compIdx,
                                                "achievement",
                                                e.target.value,
                                              );
                                              autoResizeTextarea(e.target);
                                            }}
                                            onInput={(e) =>
                                              autoResizeTextarea(
                                                e.currentTarget,
                                              )
                                            }
                                            style={{ overflow: "hidden" }}
                                          />
                                        </td>
                                      </tr>
                                    );
                                  },
                                )}
                              </tbody>
                            </table>
                          </div>
                          {(() => {
                            const endDate =
                              getappraisalTiming?.data?.employee_end_date;
                            const today = new Date();
                            const isExpired =
                              endDate &&
                              new Date(endDate) <
                                new Date(today.toISOString().split("T")[0]);

                            if (
                              isExpired ||
                              getappraisalTiming?.data
                                ?.apprisal_cycle_status === "closed" ||
                              getappraisalTiming?.data
                                ?.apprisal_cycle_status === "suspended"
                            ) {
                              return (
                                <div className="alert alert-danger text-center m-2">
                                  Your appraisal submission date is over. Please
                                  contact the HR team.
                                </div>
                              );
                            }

                            if (getPMSStatus?.data?.status === "Submit") {
                              return null;
                            }

                            return (
                              <div className="p-2 d-flex justify-content-end gap-2">
                                <div>
                                  <button
                                    className="btn btn-primary tab-button"
                                    onClick={(e: any) =>
                                      handleSaveOrSubmitBeha(e)
                                    }
                                  >
                                    Save & Next
                                  </button>
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      ) : (
                        <div className="p-2 d-flex justify-content-center">
                          <p
                            className="text-danger fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            No Behavioural Competence records found.
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="p-3 text-center">
                      <p
                        className="fw-bold text-primary"
                        style={{ fontSize: "15px" }}
                      >
                        Behavioural Competence details will be available once
                        the Goal Profile is approved by your Manager.
                      </p>
                      <p className="text-muted">
                        Current Status:{" "}
                        <strong>
                          {getGoalProfileStatus?.data?.status === "E Submit"
                            ? "Employee Submit"
                            : getGoalProfileStatus?.data?.status ===
                                "M Approved"
                              ? "Manager Approved"
                              : "Rejected"}
                        </strong>
                      </p>
                    </div>
                  )}
                </>
              ) : activetab === "Potential" ? (
                <>
                  {getGoalProfileStatus?.data?.status === "M Approved" ? (
                    <>
                      {potentialData && potentialData?.length > 0 ? (
                        <div className="custom-table-wrapper">
                          <div className="custom-table-responsive">
                            <table className="custom-table">
                              <thead>
                                <tr>
                                  <th>SNo</th>
                                  <th>Category</th>
                                  <th>Description</th>
                                  <th>Self Rating</th>
                                  <th>Self Achievement</th>
                                </tr>
                              </thead>
                              <tbody>
                                {potentialData?.map(
                                  (item: any, catIdx: number) =>
                                    item?.subcategories.map(
                                      (subItem: any, subIdx: any) => {
                                        const showSNo = subIdx === 0;
                                        const showCategory = subIdx === 0;
                                        const rowSpanCount =
                                          item.subcategories.length;

                                        return (
                                          <tr key={`row-${catIdx}-${subIdx}`}>
                                            {showSNo ? (
                                              <td
                                                rowSpan={rowSpanCount}
                                                className="allcolor"
                                              >
                                                {catIdx + 1}
                                              </td>
                                            ) : null}
                                            {showCategory ? (
                                              <td
                                                rowSpan={rowSpanCount}
                                                className="allcolor"
                                              >
                                                {item.category}
                                              </td>
                                            ) : null}
                                            <td className="allcolor">
                                              {subItem.subcategory}
                                            </td>
                                            <td>
                                              <select
                                                className="form-select"
                                                value={subItem?.rating || ""}
                                                onChange={(e) =>
                                                  handlePotensialChange(
                                                    catIdx,
                                                    subIdx,
                                                    "rating",
                                                    e.target.value,
                                                  )
                                                }
                                                disabled={
                                                  getPMSStatus?.data?.status ===
                                                  "Submit"
                                                }
                                              >
                                                <option value="">
                                                  Select Rating
                                                </option>
                                                {ratingOptions?.map(
                                                  (
                                                    ratingItem: any,
                                                    index: number,
                                                  ) => (
                                                    <option
                                                      key={index}
                                                      value={ratingItem?.value}
                                                    >
                                                      {ratingItem.label}
                                                    </option>
                                                  ),
                                                )}
                                              </select>
                                            </td>

                                            <td>
                                              <textarea
                                                className="custom-textarea"
                                                name="achievement"
                                                value={
                                                  subItem?.achievement || ""
                                                }
                                                onChange={(e) => {
                                                  handlePotensialChange(
                                                    catIdx,
                                                    subIdx,
                                                    "achievement",
                                                    e.target.value,
                                                  );
                                                  autoResizeTextarea(e.target);
                                                }}
                                                onInput={(e) =>
                                                  autoResizeTextarea(
                                                    e.currentTarget,
                                                  )
                                                }
                                                style={{ overflow: "hidden" }}
                                              />
                                            </td>
                                          </tr>
                                        );
                                      },
                                    ),
                                )}
                              </tbody>
                            </table>
                          </div>

                          {(() => {
                            const endDate =
                              getappraisalTiming?.data?.employee_end_date;
                            const today = new Date();
                            const isExpired =
                              endDate &&
                              new Date(endDate) <
                                new Date(today.toISOString().split("T")[0]);

                            if (
                              isExpired ||
                              getappraisalTiming?.data
                                ?.apprisal_cycle_status === "closed" ||
                              getappraisalTiming?.data
                                ?.apprisal_cycle_status === "suspended"
                            ) {
                              return (
                                <div className="alert alert-danger text-center m-2">
                                  Your appraisal submission date is over. Please
                                  contact the HR team.
                                </div>
                              );
                            }

                            if (getPMSStatus?.data?.status === "Submit") {
                              return null;
                            }

                            return (
                              <div className="p-2 d-flex justify-content-end gap-2">
                                <button
                                  className="btn btn-primary tab-button"
                                  onClick={(e: any) =>
                                    handleSaveOrSubmitPotensial(e)
                                  }
                                >
                                  Save & Next
                                </button>
                              </div>
                            );
                          })()}
                        </div>
                      ) : (
                        <div className="p-2 d-flex justify-content-center">
                          <p
                            className="text-danger fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            No Potential records found
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="p-3 text-center">
                      <p
                        className="fw-bold text-primary"
                        style={{ fontSize: "15px" }}
                      >
                        Potential details will be available once the Goal
                        Profile is approved by your Manager.
                      </p>
                      <p className="text-muted">
                        Current Status:{" "}
                        <strong>
                          {getGoalProfileStatus?.data?.status === "E Submit"
                            ? "Employee Submit"
                            : getGoalProfileStatus?.data?.status ===
                                "M Approved"
                              ? "Manager Approved"
                              : "Rejected"}
                        </strong>
                      </p>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {getGoalProfileStatus?.data?.status === "M Approved" ? (
                    <>
                      {getPMSStatusManager?.data?.status ===
                      "Manager Submitted" ? (
                        <div className="px-3 mt-2 mb-2">
                          <div>
                            You are requested to attend a 1:1 meeting with your
                            manager to review your performance over the past
                            year and seek feedback on strengths and areas of
                            improvement.
                          </div>
                          <div className="d-flex gap-2 justify-content-end mt-1">
                            {/* <button
                              className="btn btn-danger"
                              onClick={(e) => {
                                ApprovedApprisalAsEmployee(e, "Reject");
                              }}
                            >
                              Revert to Manager
                            </button> */}
                            <button
                              className="btn btn-success"
                              onClick={(e) => {
                                ApprovedApprisalAsEmployee(e, "Confirm");
                              }}
                            >
                              Confirm 1 on 1 Meeting
                            </button>
                          </div>
                        </div>
                      ) : null}
                      {kraDetailsData &&
                      kraDetailsData.length > 0 &&
                      behaDetailsData &&
                      behaDetailsData.length > 0 ? (
                        <>
                          {/* <table className="overall-table">
                            <thead>
                              <tr>
                                <th></th>
                                <th>KRA Rating</th>
                                <th>Potential Rating</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Self</td>
                                <td>
                                  {getPMStotalRating?.data?.kraRating?.toFixed(
                                    2,
                                  )}
                                </td>
                                <td>
                                  {getPMStotalRating?.data?.PotensialRating?.toFixed(
                                    2,
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table> */}
                          <div className="row mt-3 px-1">
                            {/* Left Column - Self Comments */}
                            <div className="col-md-6 mb-3">
                              <h5 className="fw-semibold mb-1">
                                Career Aspirations
                              </h5>
                              <div>
                                <textarea
                                  className="overall-comments-textarea form-control w-100"
                                  rows={5}
                                  value={
                                    comaspiDetailsData?.employee_carrier_aspiration
                                  }
                                  readOnly
                                />
                              </div>
                            </div>

                            {/* Right Column - Manager Comments */}
                            <div className="col-md-6 mb-3">
                              <h5 className="fw-semibold mb-1">
                                Manager Career Aspirations
                              </h5>
                              <div>
                                <textarea
                                  className="overall-comments-textarea form-control w-100"
                                  rows={5}
                                  value={
                                    comaspiDetailsData?.manager_carrier_aspiration
                                  }
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row mt-3 px-1">
                            {/* Right Column - Manager Comments */}
                            <div className="col-md-12 mb-3">
                              <h5 className="fw-semibold mb-1">
                                Overall Comments
                              </h5>
                              <div>
                                <textarea
                                  name="comments"
                                  className="overall-comments-textarea form-control w-100"
                                  rows={5}
                                  value={comaspiDetailsData?.comments}
                                  onChange={getInputdata}
                                  readOnly={
                                    getPMSStatus?.data?.status === "Submit"
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          {(comaspiDetailsData?.skip_manager_carrier_aspiration ||
                            comaspiDetailsData?.skip_manager_comments) && (
                            <div className="row mt-3 px-1">
                              <div className="col-md-12 mb-3">
                                <h5 className="fw-semibold mb-1">
                                  Manager Overall Comments
                                </h5>
                                <div>
                                  <textarea
                                    className="overall-comments-textarea form-control w-100"
                                    rows={5}
                                    value={
                                      comaspiDetailsData?.manager_comments || ""
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 mb-3">
                                <h5 className="fw-semibold mb-1">
                                  Skip Manager Career Aspirations
                                </h5>
                                <div>
                                  <textarea
                                    className="overall-comments-textarea form-control w-100"
                                    rows={5}
                                    value={
                                      comaspiDetailsData?.skip_manager_carrier_aspiration ||
                                      ""
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>

                              <div className="col-md-6 mb-3">
                                <h5 className="fw-semibold mb-1">
                                  Skip Manager Overall Comments
                                </h5>
                                <div>
                                  <textarea
                                    className="overall-comments-textarea form-control w-100"
                                    rows={5}
                                    value={
                                      comaspiDetailsData?.skip_manager_comments ||
                                      ""
                                    }
                                    readOnly
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          {(() => {
                            const endDate =
                              getappraisalTiming?.data?.employee_end_date;
                            const today = new Date();
                            const isExpired =
                              endDate &&
                              new Date(endDate) <
                                new Date(today.toISOString().split("T")[0]);

                            if (
                              isExpired ||
                              getappraisalTiming?.data
                                ?.apprisal_cycle_status === "closed" ||
                              getappraisalTiming?.data
                                ?.apprisal_cycle_status === "suspended"
                            ) {
                              return (
                                <div className="alert alert-danger text-center m-2">
                                  Your appraisal submission date is over. Please
                                  contact the HR team.
                                </div>
                              );
                            }

                            if (getPMSStatus?.data?.status === "Submit") {
                              return null;
                            }

                            return (
                              <div className="p-2 d-flex justify-content-end gap-2">
                                <div>
                                  <button
                                    className="btn btn-primary custom_button"
                                    onClick={(e: any) =>
                                      handleSaveOrSubmitComAspi(e)
                                    }
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            );
                          })()}
                        </>
                      ) : (
                        <div className="p-2 d-flex justify-content-center">
                          <p
                            className="text-danger fw-bold"
                            style={{ fontSize: "15px" }}
                          >
                            No Overall Comments records found.
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="p-3 text-center">
                      <p
                        className="fw-bold text-primary"
                        style={{ fontSize: "15px" }}
                      >
                        Overall Comments details will be available once the Goal
                        Profile is approved by your Manager.
                      </p>
                      <p className="text-muted">
                        Current Status:{" "}
                        <strong>
                          {getGoalProfileStatus?.data?.status === "E Submit"
                            ? "Employee Submit"
                            : getGoalProfileStatus?.data?.status ===
                                "M Approved"
                              ? "Manager Approved"
                              : "Rejected"}
                        </strong>
                      </p>
                    </div>
                  )}
                </>
              )}
            </section>
          )}
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© 2025 WeConnect. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <div
        id="ratinginfo"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="standard-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="standard-modalLabel">
                Ratings & Calculation of your score
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h5>
                  This year we are using a 5 point rating scale. The value
                  assigned to each rating is as below.
                </h5>
              </div>

              {/* Dynamic Ratings Table */}
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Rating</th>
                    <th>Description</th>
                    <th>Code</th>
                    <th>Scale</th>
                  </tr>
                </thead>
                <tbody>
                  {ratingData && ratingData.length > 0 ? (
                    [...ratingData]
                      .reverse()
                      .map((item: any, index: number) => (
                        <tr key={index}>
                          <td>{item.rating}</td>
                          <td>{item.name}</td>
                          <td>{item.code}</td>
                          <td>{item.scale}</td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No rating data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="mt-3">
                <p>
                  Your score is determined entirely by your score on your
                  KRA/KPI OR a composite where the weight of the KRA is 80%,
                  Potential is 20%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="behaviouralinfo"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="behavioural-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="behavioural-modalLabel">
                Behavioural Competency – Rating Scale
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h5>
                  Behavioural competencies are assessed using a 4-level scale
                  ranging from Low (L1) to Exceeds Expectations (L4).
                </h5>
              </div>

              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Level</th>
                    <th>Rating</th>
                    <th>Description</th>
                    <th>Expectation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>L1</td>
                    <td>Low</td>
                    <td>
                      Behaviour does not meet role requirements. Frequently
                      demonstrates gaps in expected competencies.
                    </td>
                    <td>Immediate improvement required</td>
                  </tr>

                  <tr>
                    <td>L2</td>
                    <td>Developing</td>
                    <td>
                      Shows basic understanding of behavioural expectations but
                      applies them inconsistently.
                    </td>
                    <td>Needs regular guidance</td>
                  </tr>

                  <tr>
                    <td>L3</td>
                    <td>Meets Expectations</td>
                    <td>
                      Consistently demonstrates expected behaviours aligned with
                      role requirements.
                    </td>
                    <td>Fully meets role standards</td>
                  </tr>

                  <tr>
                    <td>L4</td>
                    <td>Exceeds Expectations</td>
                    <td>
                      Frequently demonstrates strong behavioural competencies
                      and positively influences others.
                    </td>
                    <td>Above role expectations</td>
                  </tr>
                </tbody>
              </table>

              <div className="mt-3">
                <p>
                  Behavioural competency ratings focus on how consistently an
                  employee demonstrates expected behaviours such as
                  collaboration, accountability, communication, and leadership.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeePMS;
